function serverConfigEndpoints(builder) {
  return {
    getServerConfig: builder.query({
      providesTags: ["serverConfig"],
      queryFn: async ({ group, accountId, env }) => {
        const queryToken = (/* @__PURE__ */ new Date()).getTime();
        const response = await fetch(
          `https://raw.githubusercontent.com/99techteam/kz-config/main/groups/${group}/${accountId}.${env}.json?t=` + queryToken,
          {
            cache: "no-store"
          }
        ).then((res) => res.json());
        return {
          data: response
        };
      }
    })
  };
}
export {
  serverConfigEndpoints as default
};
